import { List } from 'immutable';
import { industryConstants } from '../constants';

export function industries(state = {}, action) {
  switch (action.type) {
    case industryConstants.INDUSTRY_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case industryConstants.INDUSTRY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case industryConstants.INDUSTRY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case industryConstants.INDUSTRY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case industryConstants.INDUSTRY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case industryConstants.INDUSTRY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case industryConstants.INDUSTRY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case industryConstants.INDUSTRY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const industryIndex = state.items.findIndex(val => val.id == action.response.id);

      if (industryIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(industryIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case industryConstants.INDUSTRY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case industryConstants.INDUSTRY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case industryConstants.INDUSTRY_DELETE_SUCCESS: {
      const { industryId } = action;

      if (!state.items) {
        return state;
      }

      const industryIndex = state.items.findIndex(val => val.id == industryId);

      if (industryIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(industryIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case industryConstants.INDUSTRY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case industryConstants.INDUSTRY_ERROR_RELOAD:
      return {
        ...state,
        editError: null,
        createError: null
      };

    default:
      return state;
  }
}
